import { render, staticRenderFns } from "./BmvLoader.vue?vue&type=template&id=19f1b76a&scoped=true"
import script from "./BmvLoader.vue?vue&type=script&lang=js"
export * from "./BmvLoader.vue?vue&type=script&lang=js"
import style0 from "./BmvLoader.vue?vue&type=style&index=0&id=19f1b76a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1b76a",
  null
  
)

export default component.exports